export default __webpack_public_path__ + "static/media/item7.091d564b.jpeg";